import { render, staticRenderFns } from "./arAging.vue?vue&type=template&id=0ba0bb1e&scoped=true"
import script from "./arAging.vue?vue&type=script&lang=js"
export * from "./arAging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba0bb1e",
  null
  
)

export default component.exports